const PRIVACY = "https://www.mozilla.org/en-US/privacy/hubs/";
const TERMS = "https://www.mozilla.org/en-US/about/legal/terms/hubs/";

module.exports = {
  PRIVACY,
  TERMS
};
